module.exports = __webpack_public_path__ + "static/media/logo2.49dd50b0.png";